import {
    Component,
    Input,
    ViewChild,
    ChangeDetectionStrategy,
    OnChanges,
} from "@angular/core";

import { Strings } from "../app.constants";
import { PersistenceService } from "../store/model/persistence.service";
import { Validity } from "../store/validity/state";
import { TrackingText, Division } from "../data/model";
import { ZbdInputComponent } from "../components/zbd-input.component";
import { map, ReplaySubject } from "rxjs";

@Component({
    selector: "tracking-text",
    exportAs: "trackingText",
    templateUrl: "tracking-text.component.html",
    styleUrls: ["./tracking-text.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingTextComponent implements OnChanges {
    protected strings = Strings;

    @Input() public name: string;
    @Input() public label: string;
    @Input("data") public trackingText: TrackingText;
    @Input() public full = true;
    @Input("show-additional") public showAdditional = true;
    @Input() public target: string;
    @Input() public division: Division;
    @Input() validity: Validity;

    @ViewChild("mainText") mainText: ZbdInputComponent;

    snippets$ = new ReplaySubject<string[]>(undefined);

    constructor(public persistence: PersistenceService) {}

    ngOnChanges() {
        if (this.target && this.division) {
            this.fetchSnippets();
        }
    }

    setTracking(enabled: boolean) {
        if (enabled) {
            const mainText = this.trackingText.AutomaticText;
            this.persistence.updateTrackingText(
                this.trackingText,
                "MainText",
                mainText,
            );
        }
        this.persistence.updateTrackingText(
            this.trackingText,
            "IsModified",
            !enabled,
            true,
        );
    }

    fetchSnippets() {
        this.persistence
            .textsForTarget(this.snippetTarget, this.division)
            .pipe(map((texts) => texts.Events.map((ev) => ev.Plaintext)))
            .subscribe(this.snippets$);
    }

    onSnippetSelect(snippet: string) {
        this.mainText.paste(snippet);
    }

    get snippetTarget() {
        return `${this.target}Snippet`;
    }
}
